import store from 'store2';

export default {
    data: () => ({
        activeDesktop: false,
        activeMobile: false,
        rankColours: {
            silver: 'grey-300',
            basic: 'teal-500',
            bronze: 'yellow-700',
            gold: 'yellow-600'
        }
    }),
    mounted() {
        this.setListeners();
        this.setDefaults();
    },
    computed: {
        count() {
            return this.cartItems.hospital && this.cartItems.extras ? 2 : 1;
        },
        priceFormatted() {
            const formatted = (Math.round(this.total * 100) / 100).toFixed(2);
            const [dollars, cents] = formatted.split('.');
            return {
                dollars,
                cents
            };
        }
    },
    methods: {
        toggleCartDesktop() {
            document.dispatchEvent(
                new CustomEvent('toggleCartDesktop', { detail: !this.activeDesktop })
            );
        },

        toggleCartMobile() {
            document.dispatchEvent(
                new CustomEvent('toggleCartMobile', { detail: !this.activeMobile })
            );
        },

        findRankColour(productTitle) {
            const keys = Object.keys(this.rankColours);
            const colour = keys.find((colour) => productTitle.toLowerCase().includes(colour));
            return colour && `bg-${this.rankColours[colour]}`;
        },

        setListeners() {
            document.addEventListener('toggleCartDesktop', (e) => {
                this.activeDesktop = e.detail;
                store.session.set('cartDesktop', e.detail);
            });

            document.addEventListener('toggleCartMobile', (e) => {
                this.activeMobile = e.detail;
                store.session.set('cartDesktop', e.detail);
            });
        },

        setDefaults() {
            this.activeMobile =
                store.session.get('cartMobile') ??
                !!document.querySelector('.cart-mobile-default-open');

            this.activeDesktop =
                store.session.get('cartDesktop') ??
                !!document.querySelector('.cart-desktop-default-open');
        }
    }
};
